// Login <-> registration page handover in sessionStorage (never in the URL: it holds the email).
// The login code token expires in a few minutes, so an old entry is dropped.
const authHandoff = {
    key: "authHandoff",
    maxAge: 5 * 60 * 1000,
    set(data) {
        try {
            sessionStorage.setItem(this.key, JSON.stringify({...data, at: Date.now()}));
        } catch (e) {}
    },
    take() {
        try {
            const data = JSON.parse(sessionStorage.getItem(this.key) || "null");
            sessionStorage.removeItem(this.key);
            if (data && Date.now() - data.at < this.maxAge) {
                return data;
            }
        } catch (e) {}
        return null;
    }
};

window.authHandoff = authHandoff;
